import route from "./modules/route";

const base = window.__POWERED_BY_QIANKUN__ ? "/portal/framework/" : "/"
let arr = route.map(item => {
  return {
    ...item,
    path: base + item.path
  }
})

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("@/views/about.vue"),
  },
  ...arr,
];

export default routes;
